module.exports = "<div class=\"errorPage\" ng-class=\"::pageClass\">\r\n    <div ng-bind-html=\"errorPageContent\" ng-if=\"!message\"></div>\r\n    <i class=\"errorPage-icon\" ng-if=\"showIcon\" ng-class=\"icon ? '{{icon}}' : 'iconww-QtyDeliveryLimit'\"></i>\r\n    <div ng-if=\"message\" ng-class=\"::messageClass\">{{message}}</div>\r\n    <div ng-if=\"secondaryMessage\" ng-class=\"::secondaryMessageClass\">{{secondaryMessage}}</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/errorpage/errorpage.directive.html
// module id = 816
// module chunks = 1